import { ComputedRoute, Route, useUnits } from '@geovelo-frontends/commons';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
  wrapper: {
    border: '1px solid #ddd',
    borderRadius: 5,
    flexDirection: 'row',
    marginTop: 30,
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  item: {
    flexGrow: 1,
    padding: '0 10px',
  },
  itemValue: {
    fontSize: 15,
  },
  divider: {
    border: '1px solid #ddd',
    flexShrink: 0,
    height: 30,
  },
});

interface IProps {
  route: ComputedRoute | Route;
}

function DataGrid({
  route: {
    distances: { total: distance },
    duration,
    calories,
  },
}: IProps): React.JSX.Element {
  const { t } = useTranslation();
  const { toDistance, toTime } = useUnits();

  return (
    <View style={styles.wrapper}>
      <View style={styles.item}>
        <Text>{t('commons.distance')}</Text>
        <Text style={styles.itemValue}>{toDistance(distance)}</Text>
      </View>
      <View style={styles.divider} />
      <View style={styles.item}>
        <Text>{t('commons.duration')}</Text>
        <Text style={styles.itemValue}>{toTime(duration)}</Text>
      </View>
      <View style={styles.divider} />
      <View style={styles.item}>
        <Text>{t('commons.routing.detail.calories')}</Text>
        <Text style={styles.itemValue}>{Math.round(calories / 1000)} kcal</Text>
      </View>
    </View>
  );
}

export default DataGrid;
